import { format, getTime, formatDistanceToNow, isValid } from 'date-fns';

function safeDate(date) {
  const d = new Date(date);
  return isValid(d) ? d : null;
}

export function fDate(date) {
  const d = safeDate(date);
  return d ? format(d, 'dd MMMM yyyy') : '';
}

export function fDateTime(date) {
  const d = safeDate(date);
  return d ? format(d, 'dd MMM yyyy HH:mm') : '';
}

export function fTimestamp(date) {
  const d = safeDate(date);
  return d ? getTime(d) : null;
}

export function fDateTimeSuffix(date) {
  const d = safeDate(date);
  return d ? format(d, 'dd/MM/yyyy hh:mm p') : '';
}

export function fToNow(date) {
  const d = safeDate(date);
  return d ? formatDistanceToNow(d, { addSuffix: true }) : '';
}
